module.exports = {
	"invoices": {
		"attributes": {
			"separate_invoice": "Fatura Avulsa",
			"code": "Código",
			"id": "ID",
			"id_alias": "ID Fatura",
			"identifier": "Identificador",
			"invoice": "Fatura",
			"order": "Pedido",
			"seller": "Vendedor",
			"status": "Status",
			"customer": "Cliente",
			"contract": "Assinatura",
			"entry": "Cobrança adicional",
			"due_date": "Data de vencimento",
			"due": "Vencimento: ",
			"paid_at": "Data de pagamento",
			"amount_due": "Valor Total",
			"contract_id_not_assigned": "Sem assinatura",
			"contract_id": "Assinatura",
			"created_at": "Data da geração",
			"created_at_initial": "Data da geração inicial",
			"paid_at_initial": "Data de pagamento inicial",
			"paid_at_end": "Data de pagamento final",
			"created_at_end": "Data da geração final",
			"due_date_initial": "Data de vencimento inicial",
			"due_date_end": "Data de vencimento final",
			"statuses": {
				"awaiting_payment": "Aguardando pagamento",
				"paid": "Pagamento efetuado",
				"reversed": "Estornado",
				"canceled": "Cancelado",
				"awaiting_approval": "Aguardando aprovação"
			}
		},
		"orders": {
			"payment_method": "Forma de pagamento",
			"not_generated": "Não gerado",
			"paid": "Pago",
			"reversed": "Estornado",
			"not_paid": "Não pago",
			"awaiting_approval": "Aguardando aprovação",
			"reproved_analysis": "Reprovada na análise"
		},
		"alerts": {
			"report_sent": "O relatório será enviado para o email: %{email}",
			"report_generated": "O relatório foi gerado.",
			"failed_to_emit_billet": "Falha ao emitir boleto",
			"not_available": "Nenhuma fatura disponível",
			"billet_sent": "Boleto enviado.",
			"successfully_generated_invoice": "Fatura gerada com sucesso",
			"generating_invoice_error": "Erro ao lançar fatura",
			"nf_not_found": "Nota Fiscal indisponível no NFE.io",
			"no_data": "Sem informações",
			"error_due_date_change": "Erro ao alterar o vencimento",
			"successful_due_date_change": "Data de vencimento alterada com sucesso",
			"successful_nf_creation": "A Nota Fiscal foi enviada para emissão com sucesso",
			"failure_nf_creation": "Falhou ao tentar criar a Nota Fiscal",
			"successful_nf_cancel": "A Nota Fiscal foi enviada para cancelamento com sucesso"
		},
		"buttons": {
			"emit_billet": "Emitir Boleto",
			"payment_link": "Link de Pagamento",
			"reverse_invoice": "Estornar Fatura",
			"set_paid": "Baixa Manual",
			"change_due_date": "Alterar data de vencimento",
			"open_tax_invoice": "Visualizar",
			"generate_tax_invoice": "Gerar",
			"cancel_tax_invoice": "Cancelar",
			"verify_orders": "Consultar processamentos"
		},
		"labels": {
			"view_billet": "Boleto",
			"send_to_same_email": "Reenviar para o e-mail de cadastro",
			"send_email_information": "Um email com o link de pagamento será enviado ao cliente.",
			"send_to_another_email": "Enviar para um outro e-mail",
			"generate_on_screen": "Gerar boleto na tela",
			"orders": "Processamentos",
			"no_orders": "Sem processamentos",
			"show_orders": "Visualizar processamentos",
			"customer_data": "Dados do cliente"
		},
		"list": {
			"title": "Faturas"
		},
		"modal_cancelation": {
			"title": "Cancelar fatura",
			"info": "Ao realizar o cancelamento, não será possível receber um pagamento referente a essa fatura. Este processo não pode ser revertido.",
			"confirm": "Confirmar cancelamento",
			"include_observation": "Inclua uma observação no cancelamento:",
			"observation": "Observação"
		},
		"modal_reverse": {
			"title": "Estornar fatura",
			"info": "Ao realizar um estorno, o pagamento da fatura em questão será revertido. Após confirmar o estorno ele não poderá ser desfeito.",
			"nf_info": "Atenção caso esta fatura possua alguma nota fiscal gerada nos útlimos 30 dias a mesma será cancelada.",
			"confirm": "Confirmar estorno",
			"include_observation": "Inclua uma observação no estorno:",
			"observation": "Observação"
		},
		"modal_confirm": {
			"title": "Baixa manual",
			"info": "A baixa manual confirma o pagamento da fatura e ativa sua referente assinatura, caso exista.<br>O status da fatura será alterado para <strong>Pagamento efetuado</strong>.<br>Este processo não pode ser revertido.",
			"confirm": "Realizar baixa"
		},
		"modal_cancel_tax_invoice": {
			"title": "Cancelar Nota Fiscal",
			"info": "Será feito o cancelamento da nota fiscal referente à essa fatura",
			"reason": "Motivo de cancelamento",
			"confirm": "Confirmar cancelamento"
		},
		"formats": {
			"csv": "Faturas_%{subdomain}_%{today}.csv"
		},
		"details": {
			"separate_invoice_information": "Envie uma cobrança avulsa ao seu cliente sempre que necessário. A cobrança será enviada como uma fatura, e será listada junto ás faturas recorrentes.",
			"title": "Detalhes da fatura",
			"period": "Período",
			"label": "Tipo",
			"invoice_emission_date": "Data de emissão da cobrança",
			"payment_date": "Data pagamento",
			"entry_date": "Data lançamento",
			"description": "Descrição",
			"value": "Valor",
			"total": "Total"
		},
		"placeholder": {
			"add_separate_invoice": "Ex: Serviço adicional"
		},
		"filter": {
			"contract_code": "Código da assinatura"
		},
		"show": {
			"invoice_data": "Dados da fatura",
			"invoice_items": "Itens da fatura"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/invoices/pt-BR.yml
// module id = 584
// module chunks = 1